import { Process, System } from '@/models/module-enums-generated'

export const moduleTypes = [System, Process] as const
